import { useReducer, useMemo } from "react"
import { findIndex, get, isObject } from "lodash"
import { DESC, getNextSort } from "helpers/sorts"

export default function useSort(columns, allowAbsoluteSort = false) {
  let defaultSortColumn = findIndex(columns, column => get(column, "defaultSort"))
  if (defaultSortColumn === -1) {
    defaultSortColumn = 0
  }

  let defaultSort = get(columns, [defaultSortColumn, "defaultSort"])
  // Most defaultSorts will only provide the direction and not a { direction, absolute } object
  if (!isObject(defaultSort)) {
    defaultSort = { direction: defaultSort }
  }

  const [{ sortByColumn, direction, absolute }, dispatchSort] = useReducer((state, action) => {
    if (action.index === state.sortByColumn) {
      const isNumeric = get(columns, [state.sortByColumn, "numeric"], false)
      return {
        sortByColumn: state.sortByColumn,
        ...getNextSort(state, isNumeric && allowAbsoluteSort),
      }
    } else {
      return {
        sortByColumn: action.index,
        direction: DESC,
      }
    }
  }, {
    sortByColumn: defaultSortColumn,
    ...defaultSort,
  })

  const [sortClass, sortValueGetter] = useMemo(() => {
    const sortClass = `${direction}${absolute ? " absolute" : ""}`
    const sortColumnDef = columns[sortByColumn]
    const transform = absolute ? value => Math.abs(value) : value => value

    let sortValueGetter
    if (typeof sortColumnDef.sortGetter === "function") {
      sortValueGetter = sortColumnDef.sortGetter
    } else {
      sortValueGetter = sortColumnDef.value ? transform(columns[sortByColumn].value) : datum => transform(datum[sortColumnDef.id])
    }

    return [sortClass, sortValueGetter]
  }, [columns, sortByColumn, absolute, direction])

  return [sortByColumn, direction, absolute, sortClass, sortValueGetter, dispatchSort]
}
